var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        width: "730",
        persistent: "",
        "no-click-animation": "",
        scrollable: "",
        "overlay-color": "grey-500",
      },
      model: {
        value: _vm.requestCafDialog,
        callback: function ($$v) {
          _vm.requestCafDialog = $$v
        },
        expression: "requestCafDialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "pa-0" },
            [
              _c(
                "v-toolbar",
                {
                  staticClass: "transparent",
                  attrs: { flat: "", height: "46" },
                },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticClass:
                        "px-5 subtitle-2 grey-700--text font-weight-semibold",
                    },
                    [_vm._v("Solicitar folios para " + _vm._s(_vm.type))]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-toolbar-items",
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "mr-3",
                          attrs: { align: "center", justify: "center" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "ml-3",
                              attrs: {
                                icon: "",
                                small: "",
                                "retain-focus-on-click": "",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.$emit("update:requestCafDialog", false),
                                    _vm.clearInput()
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { attrs: { color: "grey-500", size: "20" } },
                                [_vm._v("mdi-close")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-text",
            { staticClass: "py-4" },
            [
              _c(
                "v-row",
                { attrs: { align: "center", "no-gutters": "" } },
                [
                  _c("v-col", { staticClass: "pa-0", attrs: { cols: "3" } }, [
                    _c("img", {
                      attrs: {
                        src: require(`@/assets/backgrounds/modal-folios-upload.svg`),
                        height: 199,
                      },
                    }),
                  ]),
                  _c(
                    "v-col",
                    { staticClass: "pr-0 pl-15 pt-0", attrs: { cols: "9" } },
                    [
                      _vm.$store?.state?.auth?.account?.country === "CL"
                        ? _c(
                            "div",
                            { staticClass: "mb-3" },
                            [
                              _c(
                                "v-alert",
                                {
                                  staticClass:
                                    "inf-alert-blue green-500--text rounded-md mt-4",
                                  attrs: {
                                    "min-height": 45,
                                    "max-height": 95,
                                    dense: "",
                                    text: "",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex pa-0 my-1" },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            color: "green-500",
                                            size: "22",
                                          },
                                        },
                                        [_vm._v("mdi-information-outline")]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "ml-4 text-description",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "body-2",
                                              staticStyle: {
                                                "line-height": "14px",
                                              },
                                            },
                                            [
                                              _vm.type === "timbraje"
                                                ? [
                                                    _vm._v(
                                                      " Los folios solicitados serán de "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "font-weight-bold",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "uso exclusivo para timbraje."
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "font-weight-bold",
                                                      },
                                                      [_vm._v("Factura X")]
                                                    ),
                                                    _vm._v(
                                                      " empleará los folios solicitados para "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "font-weight-bold",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "asignar numeración a los documentos."
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                            ],
                                            2
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-col",
                        { staticClass: "px-0 pt-0", attrs: { cols: "12" } },
                        [
                          _c("span", { staticClass: "grey-500--text body-1" }, [
                            _vm._v("Tipo de documento"),
                          ]),
                          _c("v-autocomplete", {
                            attrs: {
                              error: _vm.$v.newCaf.document_type.$error,
                              label:
                                "Selecciona el tipo de documento a solicitar",
                              items: _vm.documentTypesList.filter(
                                ({ country }) =>
                                  country ==
                                  _vm.$store?.state?.auth?.account?.country
                              ),
                              "item-value": "id",
                              "item-text": "name",
                              "menu-props": {
                                overflowY: true,
                                transition: "slide-y-transition",
                              },
                              height: "30",
                              "single-line": "",
                              outlined: "",
                              dense: "",
                              "hide-details": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "v-list-item-title",
                                      { staticClass: "font-weight-regular" },
                                      [_vm._v(_vm._s(data.item.name))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                            model: {
                              value: _vm.$v.newCaf.document_type.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.newCaf.document_type,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.newCaf.document_type.$model",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "px-0 pt-0", attrs: { cols: "4" } },
                        [
                          _c("span", { staticClass: "grey-500--text body-1" }, [
                            _vm._v("Cantidad de folios"),
                          ]),
                          _c("v-text-field", {
                            attrs: {
                              error: _vm.$v.newCaf.quantity.$error,
                              outlined: "",
                              required: "",
                              "single-line": "",
                              dense: "",
                              maxlength: "100",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.$v.newCaf.quantity.$model,
                              callback: function ($$v) {
                                _vm.$set(_vm.$v.newCaf.quantity, "$model", $$v)
                              },
                              expression: "$v.newCaf.quantity.$model",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-actions",
            { staticClass: "px-5 py-2" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { outlined: "" },
                  on: {
                    click: function ($event) {
                      _vm.$emit("update:requestCafDialog", false),
                        _vm.clearInput()
                    },
                  },
                },
                [_vm._v("Cancelar")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "grey-900", loading: _vm.loadingCreateCaf },
                  on: { click: _vm.createNumbering },
                },
                [_vm._v("Cargar folios")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }